import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import type { NavigateFunction } from 'react-router-dom';
import { InfoCircleFilled } from '@ant-design/icons';
import { logout } from '../../api';
import { IPC } from '../../../common/ipc/channels';
import { APP_REPORT_EVENTS } from '../../../common/enums/appReport';
import { appReporter } from '../../utils/appReporter';

interface LogoutModalProps {
  open: boolean;
  onClose: () => void;
  clearAuthSession: () => void;
  setCurrentEcomAccountId: (id: string) => void;
  navigate: NavigateFunction;
}

export const LogoutModal: React.FC<LogoutModalProps> = ({
  open,
  onClose,
  clearAuthSession,
  setCurrentEcomAccountId,
  navigate,
}) => {
  const [logoutSubmitting, setLogoutSubmitting] = useState(false);

  const handleConfirmLogout = async () => {
    if (logoutSubmitting) {
      return;
    }

    void appReporter.reportAuthEvent(APP_REPORT_EVENTS.LOGOUT_CONFIRM_CLICK, {
      triggerArea: 'profile_menu',
    });
    setLogoutSubmitting(true);
    try {
      try {
        await logout();
      } catch {
        // 即使接口失败也继续清理本地登录态，避免用户被卡在当前页面。
      }

      if (window.electronAPI) {
        try {
          await window.electronAPI.invoke(IPC.CLEAR_API_AUTH_SESSION);
        } catch (error) {
          console.error('Failed to clear native auth session.', error);
        }
      }

      clearAuthSession();
      setCurrentEcomAccountId('');
      onClose();
      navigate('/login', { replace: true });
    } finally {
      setLogoutSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      centered
      closable={false}
      footer={null}
      width={556}
      destroyOnHidden
      maskClosable={!logoutSubmitting}
      onCancel={() => {
        if (!logoutSubmitting) {
          onClose();
        }
      }}
      className="main-layout__logout-modal"
    >
      <div className="main-layout__logout-modal-body">
        <div className="main-layout__logout-modal-title-row">
          <InfoCircleFilled className="main-layout__logout-modal-icon" />
          <span className="main-layout__logout-modal-title">退出登录</span>
        </div>
        <p className="main-layout__logout-modal-description">
          退出后，如有当前正在执行的任务，不受影响，可在下次登录后查看。
        </p>
        <div className="main-layout__logout-modal-actions">
          <Button
            className="main-layout__logout-modal-cancel"
            onClick={onClose}
            disabled={logoutSubmitting}
          >
            取消
          </Button>
          <Button
            type="primary"
            className="main-layout__logout-modal-submit"
            loading={logoutSubmitting}
            onClick={() => void handleConfirmLogout()}
          >
            退出登录
          </Button>
        </div>
      </div>
    </Modal>
  );
};
